import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import i18n from 'i18n';

type SaveTxnModalProps = {
  onClose: () => void;
  onSave: () => void;
};

const SaveTxnModal = (props: SaveTxnModalProps) => {
  return (
    <Modal show={true} id={'qa-save-transaction'} onHide={props.onClose}>
      <Modal.Header closeButton id="qa-modal-assign-template-btn-close-icon">
        <h5 className="modal-title">{i18n.t('transactions:processingActions.notification.title')}</h5>
      </Modal.Header>
      <Modal.Body>
        <p>{i18n.t('transactions:processingActions.notification.body')}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button id={'cancel-txn-save-btn'} variant="link" onClick={props.onClose}>
          {i18n.t('common:actions.cancel')}
        </Button>
        <Button id={'approve-txn-save-btn'} variant="primary" onClick={props.onSave}>
          {i18n.t('transactions:processingActions.modal.save')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SaveTxnModal;
